module.exports = __webpack_public_path__ + "molino-vigevano.svg?40e1b84c324fc32c52c2d61ab366848f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/molino-vigevano.svg
// module id = 126
// module chunks = 0